import { useState, useEffect } from 'react'
import useClient from './useClient'
import cloneDeep from 'lodash.clonedeep'

export default function useAssets() {
  const [assets, setAssets] = useState({})
  const {
    client,
    catalogLoading
  } = useClient()

  useEffect(() => {
    if (client != null && !catalogLoading) {
      setAssets(cloneDeep(client.catalog.assets))
    }
  }, [client, catalogLoading])

  return {
    assets
  }
}
